<div
  class="panel"
  [ngClass]="{ error: panelType == 'error', info: panelType == 'info' }"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <div>{{ messageText }}</div>
  <div *ngIf="canClose">
    <button style="width: 24px" mat-icon-button (click)="onPanelClose()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
</div>
